//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import Confirm from '../../shared-components/vuetify/dialog/Confirm';
import Divisao from './Divisao';
import MetadadosContainerLayout from '../../shared-components/metadados/MetadadosContainerLayout';

export default {
  name: 'DivisaoForm',
  data() {
    return {
      buscaListaEstruturaUsuario: null,
      buscaListaDivisoesSuperiores: null,
      buscaListaCarteiras: null,
      carteirasClienteResources: this.$api.carteiraCliente(this.$resource),
      divisao: new Divisao(),
      divisaoResources: this.$api.divisao(this.$resource),
      estruturaUsuarioResources: this.$api.estruturaUsuario(this.$resource),
      inputLayout: {
        xs12: true,
        sm12: true,
        md12: true,
        sm6: false,
        md3: false,
        md4: false,
        md6: false,
        md9: false,
      },
      layoutClass: { wrap: true },
      listaCarteirasCliente: [],
      listaDivisoes: [],
      listaEstruturaUsuarios: [],
      vlrSelecaoEstrutura: {},
      dialog: {
        content: '',
      },
      rules: {
        required: value => !!value || this.$t('message.campo_obrigatorio'),
        requiredEstrutura: value => (!!value && !!value.id) || this.$t('message.campo_obrigatorio'),
        requiredMultiplaSelecao: value => value.length > 0 || this.$t('message.campo_obrigatorio'),
      },
    };
  },
  props: {
    configCarteira: String,
  },
  watch: {
    buscaListaCarteiras(val) {
      if (this.timeoutCarteira) {
        window.clearTimeout(this.timeoutCarteira);
      }
      this.timeoutCarteira = window.setTimeout(() => {
        if (val != null) this.buscarCarteirasCliente(val);
      }, 500);
    },
    buscaListaDivisoesSuperiores(val) {
      if (this.timeoutDivisao) {
        window.clearTimeout(this.timeoutDivisao);
      }
      this.timeoutDivisao = window.setTimeout(() => {
        if (val != null) this.buscarDivisoesPorEstruturaDeUsuario(val);
      }, 500);
    },
    buscaListaEstruturaUsuario(val) {
      if (this.divisao.estruturaUsuario && this.divisao.estruturaUsuario.nomEstruturaUsuario) {
        const selecao = this.divisao.estruturaUsuario.nomEstruturaUsuario;
        if (selecao === val) {
          return;
        }
      }

      if (this.timeoutEstrutura) {
        window.clearTimeout(this.timeoutEstrutura);
      }
      this.timeoutEstrutura = window.setTimeout(() => {
        if (val != null) this.buscarEstruturasDeUsuario(val);
      }, 500);
    },
  },
  components: {
    Confirm,
    MetadadosContainerLayout,
  },
  computed: {
    ...mapGetters('metadados', [
      'getDivisaoMetadado',
    ]),
    metadadosDivisao() {
      if (this.getDivisaoMetadado && this.getDivisaoMetadado.mapaEntidades) {
        return this.getDivisaoMetadado;
      }
      return undefined;
    },
  },
  methods: {
    buscarCarteirasCliente(filtroComponente) {
      return this.carteirasClienteResources.listarAtivos(filtroComponente)
        .then((resultado) => {
          this.listaCarteirasCliente = resultado.data.resposta;
          const selecao = this.divisao.carteirasCliente;
          this.listaCarteirasCliente = [...selecao, ...this.listaCarteirasCliente];
        });
    },
    buscarDivisoesPorEstruturaDeUsuario(nome) {
      const filtro = {
        idEstruturaUsuario: this.divisao.estruturaUsuario.id,
        nome,
      };
      return this.divisaoResources.pesquisasrDivisoesSuperiores(filtro)
        .then((resultado) => {
          this.listaDivisoes = resultado.data.resposta;
          const selecao = this.divisao.divisoesSuperiores;
          this.listaDivisoes = [...selecao, ...this.listaDivisoes];
        });
    },
    buscarEstruturasDeUsuario(nomEstruturaUsuario) {
      const param = {
        autocomplete: nomEstruturaUsuario,
      };
      return this.estruturaUsuarioResources.selecao(param)
        .then((resultado) => {
          this.listaEstruturaUsuarios = resultado.data;
        });
    },
    cancel() {
      this.limparFormulario();
      this.$emit('FORMULARIO_CADASTRO_DIVISAO_CANCELAR');
    },
    editar(divisao) {
      this.divisao = new Divisao({ ...divisao });
      this.divisao.montarEstruturaDinamica(divisao, this.metadadosDivisao);
    },
    limparFormulario() {
      this.divisao = new Divisao();
      this.$refs.form.reset();
    },
    closeDialog(ref, cb) {
      this.$refs[ref].close();
      this.$refs[ref].active = false;
      if (cb) {
        cb();
      }
    },
    openSaveDialog() {
      if (!this.$refs.form.validate()) return;
      this.dialog.content = this.$t('message.salvar_nova_divisao');
      this.$refs.confirmDialog.open();
    },
    onEstruturaUsuarioSelecionada(estruturaUsuarioSelecionada) {
      if (!estruturaUsuarioSelecionada) {
        if (this.divisao && this.divisao.estruturaUsuario) {
          this.divisao.estruturaUsuario = null;
        }
        this.buscarEstruturasDeUsuario();
        return;
      }
      this.buscarDivisoesPorEstruturaDeUsuario();
    },
    isDivisoesSuperioresDisabled() {
      if (this.divisao && this.divisao.estruturaUsuario) {
        return !this.divisao.estruturaUsuario.id;
      }
      return true;
    },
    removeChipSelecao(item) {
      const selecao = this.divisao.divisoesSuperiores;
      const index = selecao.map(s => s.id).indexOf(item.id);
      if (index >= 0) selecao.splice(index, 1);
    },
    save() {
      const objArmazenamento = { ...this.divisao };
      objArmazenamento.dependenciasMetadados = this.$refs.container.getValoresDependencias();

      let salvarOuAtualizar;
      if (this.divisao.id != null) {
        salvarOuAtualizar = this.divisaoResources.atualizarDivisao({ id: this.divisao.id },
        objArmazenamento);
      } else {
        salvarOuAtualizar = this.divisaoResources.gravar(objArmazenamento);
      }

      salvarOuAtualizar.then(() => this.limparFormulario())
        .then(() => this.$toast.create(this.$t('message.adicionado_confira_tabela')
          , 'snack', 3E3))
        .then(() => {
          this.$emit('FORMULARIO_CADASTRO_DIVISAO_SALVAR');
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
  },
  mounted() {
    this.buscarEstruturasDeUsuario();
    this.buscarCarteirasCliente();
  },
};



// WEBPACK FOOTER //
// ./src/spa/divisao/DivisaoForm.vue?vue&type=script&lang=js&